module.exports = __webpack_public_path__ + "1f0105bc3a6666729c11d80ffa1ae919.svg";